import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import resources from "./i18n/config";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    debug: false,
    load: "languageOnly",
    supportedLngs: ["en", "es", "fr", "de", "zh", "tr", "ru", "it", "uk"],
  });

export default i18n;
